var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.142083333,0.340083333 C0.0568333333,0.374916667 0,0.457416667 0,0.55 L0,0.55 L0,4.12591667 C0,4.88491667 0.616,5.5 1.375,5.5 L1.375,5.5 L4.95,5.5 C5.04258333,5.5 5.126,5.44408333 5.16266667,5.35883333 L5.16266667,5.35883333 C5.1975,5.27358333 5.17825,5.17458333 5.11225,5.10858333 L5.11225,5.10858333 L0.391416667,0.3905 C0.347416667,0.345583333 0.28875,0.322666667 0.230083333,0.322666667 L0.230083333,0.322666667 C0.199833333,0.322666667 0.1705,0.32725 0.142083333,0.340083333 L0.142083333,0.340083333 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.572916667,0.903833333 L0.572916667,4.54941667 C0.575666667,4.62 0.61325,4.686 0.671916667,4.72358333 L0.671916667,4.72358333 C0.732416667,4.76208333 0.806666667,4.7685 0.872666667,4.74283333 L0.872666667,4.74283333 C1.66466667,4.39633333 2.178,3.61258333 2.178,2.74725 L2.178,2.74725 C2.178,1.88283333 1.66466667,1.1 0.872666667,0.7535 L0.872666667,0.7535 L0.87175,0.7535 C0.840583333,0.740666667 0.798416667,0.730583333 0.755333333,0.730583333 L0.755333333,0.730583333 C0.6655,0.730583333 0.572916667,0.771833333 0.572916667,0.903833333 L0.572916667,0.903833333 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.803916667,0.571083333 C0.6765,0.571083333 0.572916667,0.674666667 0.572916667,0.802083333 L0.572916667,0.802083333 L0.572916667,1.94425 C0.572916667,2.07166667 0.6765,2.17616667 0.803916667,2.17616667 L0.803916667,2.17616667 L1.375,2.17616667 C1.81775,2.17616667 2.178,1.81591667 2.178,1.37408333 L2.178,1.37408333 C2.178,0.930416667 1.81775,0.571083333 1.375,0.571083333 L1.375,0.571083333 L0.803916667,0.571083333 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83333333,0.000916666667 C0.820416667,0.000916666667 0,0.820416667 0,1.83425 L0,1.83425 L0,20.1666667 C0,21.1795833 0.820416667,22 1.83333333,22 L1.83333333,22 L16.5,22 C17.512,22 18.3333333,21.1795833 18.3333333,20.1666667 L18.3333333,20.1666667 L18.3333333,6.64491667 C18.3324167,6.51841667 18.22975,6.41666667 18.1041667,6.41666667 L18.1041667,6.41666667 L14.2083333,6.41666667 C12.9424167,6.41666667 11.9166667,5.39 11.9166667,4.12591667 L11.9166667,4.12591667 L11.9166667,0.227333333 C11.91575,0.10175 11.8130833,0.000916666667 11.6875,0.000916666667 L11.6875,0.000916666667 L1.83333333,0.000916666667 Z M12.2604167,17.4175833 L12.2604167,12.8333333 C12.2604167,12.0101667 12.9268333,11.34375 13.75,11.3419167 L13.75,11.3419167 L15.5833333,11.3419167 C15.9005,11.3419167 16.1571667,11.5985833 16.1571667,11.91575 L16.1571667,11.91575 C16.1571667,12.2310833 15.9005,12.48775 15.5833333,12.48775 L15.5833333,12.48775 L13.75,12.48775 C13.5593333,12.48775 13.40625,12.64175 13.40625,12.8324167 L13.40625,12.8324167 L13.40625,13.8609167 C13.40625,13.9883333 13.5098333,14.0928333 13.63725,14.0928333 L13.63725,14.0928333 L14.6666667,14.0928333 C14.9838333,14.0928333 15.2395833,14.3485833 15.2395833,14.6648333 L15.2395833,14.6648333 C15.2395833,14.9810833 14.9838333,15.2386667 14.6666667,15.2386667 L14.6666667,15.2386667 L13.63725,15.2386667 C13.5098333,15.2386667 13.40625,15.3404167 13.40625,15.4696667 L13.40625,15.4696667 L13.40625,17.4175833 C13.40625,17.7329167 13.1495833,17.9895833 12.8333333,17.9895833 L12.8333333,17.9895833 C12.5170833,17.9895833 12.2604167,17.7329167 12.2604167,17.4175833 L12.2604167,17.4175833 Z M7.67707307,17.4175833 L7.67707307,11.9166667 C7.67616667,11.7635833 7.73666667,11.61875 7.84391667,11.5105833 L7.84391667,11.5105833 C7.95116667,11.4024167 8.09691667,11.3419167 8.25,11.3419167 L8.25,11.3419167 C10.0860833,11.3419167 11.5729167,12.8296667 11.5729167,14.6648333 L11.5729167,14.6648333 C11.5729167,16.5009167 10.0860833,17.9886667 8.25,17.9886667 L8.25,17.9886667 C7.93375,17.9886667 7.678,17.7329167 7.67707307,17.4175833 L7.67707307,17.4175833 Z M3.09373973,17.4175833 L3.09373973,11.9166667 C3.09283333,11.7635833 3.15333333,11.61875 3.2615,11.5105833 L3.2615,11.5105833 C3.36875,11.4024167 3.5145,11.3419167 3.66666667,11.3419167 L3.66666667,11.3419167 L5.04166667,11.3419167 C6.11691667,11.3419167 6.98958333,12.2136667 6.98958333,13.29075 L6.98958333,13.29075 C6.98958333,14.366 6.11691667,15.2386667 5.04166667,15.2386667 L5.04166667,15.2386667 L4.47058333,15.2386667 C4.34316667,15.2386667 4.23958333,15.3404167 4.23958333,15.4696667 L4.23958333,15.4696667 L4.23958333,17.4175833 C4.23958333,17.7329167 3.98291667,17.9895833 3.66666667,17.9895833 L3.66666667,17.9895833 C3.35041667,17.9895833 3.09373973,17.7329167 3.09373973,17.4175833 L3.09373973,17.4175833 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/pdf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.833333, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#0091EA",
    mask: "url(#mask-2)",
    points: "-4.58333333 10.0833333 9.7625 10.0833333 9.7625 -4.26066667 -4.58333333 -4.26066667"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(8.250000, 11.916667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#0091EA",
    mask: "url(#mask-4)",
    points: "-4.01041667 9.34175 6.76041667 9.34175 6.76041667 -3.85275 -4.01041667 -3.85275"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(3.666667, 11.916667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#0091EA",
    mask: "url(#mask-6)",
    points: "-4.01041667 6.75858333 6.76041667 6.75858333 6.76041667 -4.01225 -4.01041667 -4.01225"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#0091EA",
    mask: "url(#mask-8)",
    points: "-4.58333333 26.5833333 22.9166667 26.5833333 22.9166667 -4.58333333 -4.58333333 -4.58333333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBlue);
export default __webpack_public_path__ + "static/media/pdfBlue.fc1fb51ff77130bd72f41ea973eb2c56.svg";
export { ForwardRef as ReactComponent };